module.exports = __webpack_public_path__ + "static/media/yandex.9961e8fb.svg";